import { Test } from './types';
import * as React from 'react';

type ActiveTestSetter = (test: Test) => void;
type ActiveTestContextValues = [Test, ActiveTestSetter];

// @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
const ActiveTestContext = React.createContext<ActiveTestContextValues>(null);

/**
 * @description A hook for reading and setting the active test prop. The active
 * test is the test currently selected/viewed by the user in the OE "Default"
 * view mode.
 */
function useActiveTest() {
  const context = React.useContext(ActiveTestContext);

  if (!context) {
    throw new Error('useActiveTest must be used within a ActiveTestContext');
  }

  return context;
}

function ActiveTestProvider(props: any) {
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  const [activeTest, setActiveTest] = React.useState<Test>(null);

  const value = React.useMemo(() => [activeTest, setActiveTest], [activeTest]);

  return <ActiveTestContext.Provider value={value} {...props} />;
}

export { ActiveTestProvider, useActiveTest };
